import React, { useEffect, useState } from "react";
import { useViewport } from "src/common/hooks/ViewPort";
import { PageContainer } from "src/components/organisms/contents";
import RoutineScore from "./components/RoutineScore";
import ListCard from "./components/ListCard";
import { HealthPointBox } from "./components/HealthPointBox";
import { useNavigate } from "react-router-dom";
import { useUserRegister } from "src/common/hooks/useUserRegister";
import { TopBackground } from "src/components/atoms/TopBackground/TopBackground";
import { ReactComponent as IconAlert } from "../../styles/assets/svg/icon_alert.svg";
import dayjs from "dayjs";

// 문자열을 해시값(숫자)으로 변환
function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // 32bit 정수로 변환
  }
  return Math.abs(hash);
}

/* 날짜 기반 랜덤 seed 값 */
function seededRandom(seed: number) {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
}

function getRandomInt(
  userOid: string,
  date: string,
  index: number,
  min: number,
  max: number
) {
  const weekStart = dayjs(date).startOf("day").format("YYYY-MM-DD");
  const seed = hashString(`${userOid}-${weekStart}-${index}`);
  const rand = seededRandom(seed);
  return Math.floor(rand * (max - min + 1)) + min;
}

function getRandomScore(userOid: string, date: string) {
  return getRandomInt(userOid, date, 0, 80, 100);
}

const HomePage: React.FC = () => {
  const { px } = useViewport();
  const navi = useNavigate();
  const today = dayjs().format("YYYY.MM.DD");
  const [routineScore, setRoutineScore] = useState<number>(0);

  const { data: userInfo, isLoading } = useUserRegister();

  useEffect(() => {
    if (isLoading) return;
    if (!userInfo) return;

    const { birthday, birthyear, gender, height, weight, workoutCount } =
      userInfo;

    if (
      !birthday ||
      !birthyear ||
      !gender ||
      !height ||
      !weight ||
      !workoutCount
    ) {
      navi("/register");
    }
  }, [userInfo, isLoading, navi]);

  useEffect(() => {
    if (isLoading) return;
    if (!userInfo) return;

    setRoutineScore(getRandomScore(userInfo.oid, today.replace(/\./g, "-")));
  }, [userInfo, isLoading, today]);

  // 고정 스펙
  // const HERO_W = 360;
  // const HERO_H = 256;
  // const HERO_R = 24;

  // const SCORE_W = 328;
  // const SCORE_H = 221;

  // // 겹침 정도
  // const OVERLAP = 170;

  // // 스코어 아래 최종 간격을 유지하기 위한 보정
  // const GAP_AFTER_SCORE = 12; // (스코어 바로 아래 최종 간격)

  const handleRowClick = (row: any) => {
    navi(`/${row}`);
  };

  return (
    <PageContainer isNavBar={true} active="home">
      <>
        {/* 상단 배경 */}
        <TopBackground />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 16,
            position: "relative",
            zIndex: 1,
            paddingBottom: "160px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "24px 0 8px",
            }}
          >
            <div
              style={{
                color: "#fff",
                fontSize: px(20),
                fontWeight: 600,
                letterSpacing: -0.2,
              }}
            >
              안녕하세요, {userInfo?.userName} 님
            </div>
            <IconAlert
              style={{ cursor: "pointer" }}
              onClick={() => navi("/alert")}
            />
          </div>
          <RoutineScore
            value={routineScore}
            title="오늘 루틴 점수"
            badgeText="건강 만렙! 완벽해요! 👍"
            formatLabel={(n) => n.toLocaleString()}
          />
          {/* 건강 포인트 */}
          <HealthPointBox
            id="healthPoint"
            onRowClick={handleRowClick}
            totalPoint={userInfo?.point?.toLocaleString() || 0}
          />
          {/* 리스트 카드 */}
          <ListCard onRowClick={handleRowClick} />
        </div>
      </>
    </PageContainer>
  );
};

export default HomePage;
